import { render, staticRenderFns } from "./StepsSideBar.vue?vue&type=template&id=065b24a0&scoped=true&lang=pug"
import script from "./StepsSideBar.vue?vue&type=script&lang=ts"
export * from "./StepsSideBar.vue?vue&type=script&lang=ts"
import style0 from "./StepsSideBar.vue?vue&type=style&index=0&id=065b24a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b24a0",
  null
  
)

export default component.exports